import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addCurrencyManagement, updCurrencyManagement } from "@/api/dataAll/currencyMapping";
export default {
  data: function data() {
    return {
      paramsData: {
        id: '',
        currency_name: '',
        currency: ''
      },
      paramsDataMark: {},
      dialogShow: false,
      rules: {
        currency_name: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        currency: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }]
      },
      currencyList: []
    };
  },
  created: function created() {
    this.paramsDataMark = JSON.parse(JSON.stringify(this.paramsData));
  },
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  for (k in _this.paramsDataMark) {
                    _this.paramsData[k] = data[k];
                  }
                }

                _context.next = 3;
                return _this.$store.dispatch("d2admin/serchSelect/getCurrency", {
                  game_id: _this.$store.state.d2admin.serchSelect.rawData.game_id
                });

              case 3:
                _this.currencyList = _context.sent;
                _this.dialogShow = true;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData(isClearId) {
      this.paramsData = _objectSpread(_objectSpread({}, this.paramsDataMark), {}, {
        id: isClearId ? '' : this.paramsData.id,
        currency: isClearId ? '' : this.paramsData.currency
      });
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.paramsData.id !== '' ? updCurrencyManagement : addCurrencyManagement;
          reqFn(_objectSpread({}, _this2.paramsData)).then(function (res) {
            if (res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$store.dispatch('d2admin/serchSelect/updCurrency');

              _this2.$emit('update');
            }
          });
        }
      });
    }
  }
};